export default __webpack_public_path__ + "static/media/metaverse.bd1b6967.png";